// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__36lgD","label":"LabeledBox_label__18g6M"};